enum ChromeActionType {
    CHROME_MANAGE_PARTS_VISIBILITY = "CHROME_MANAGE_PARTS_VISIBILITY",
}

export default ChromeActionType;